/** URL segment for the learners-hub route. */
export const LEARNERS_HUB_SEGMENT = 'learners-hub';

/**
 * Parses a pathname into learners-hub section and subsection slugs.
 */
export function getLearnersHubPathSegments(
  pathname: string | null,
  tenant: string,
): {
  segmentAfterHub: string[];
  sectionSlug: string | null;
  subsectionSlug: string | null;
} {
  const segments = pathname?.split('/').filter(Boolean) ?? [];
  const hubIndex =
    segments.indexOf(tenant) >= 0 ? segments.indexOf(tenant) + 1 : -1;
  const segmentAfterHub =
    hubIndex >= 0 && segments[hubIndex] === LEARNERS_HUB_SEGMENT
      ? segments.slice(hubIndex + 1)
      : [];
  return {
    segmentAfterHub,
    sectionSlug: segmentAfterHub[0] ?? null,
    subsectionSlug: segmentAfterHub[1] ?? null,
  };
}
